const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  queue: (state) => state.queue.queue,
  currentQueueItem: (state) => state.queue.currentQueueItem,
  currentImage: (state) => state.queue.currentImage,
  currentCompanies: (state) => state.queue.currentCompanies,
  getMeters: (state) => state.queue.meters,
  fetchingCompanies: (state) => state.queue.fetchingCompanies,
  loadingMore: (state) => state.queue.loadingMore,
  fetchingMeters: (state) => state.queue.fetchingMeters,
  currentMeter: (state) => state.queue.currentMeter,
  currentCompany: (state) => state.queue.currentCompany,
  getDateOn: (state) => state.queue.dateOn,
  getTimeOn: (state) => state.queue.timeOn,
  getDateOff: (state) => state.queue.dateOff,
  getTimeOff: (state) => state.queue.timeOff,
  getBatchDetail: (state) => state.queue.batchDetail,
  getIsSaveError: (state) => state.queue.isSaveError,
  getSaveStatus: (state) => state.queue.saveStatus,
  getMeterDetail: (state) => state.queue.meterDetail,
  getIsSaving: (state) => state.queue.isSaving,
  getMeterVolumetric: (state) => state.queue.meterVolumetric,
  getIsNilChart: (state) => state.queue.currentQueueItem.isNilChart,
  getExcludeChart: (state) => state.queue.currentQueueItem.excludeFromAutoIntegration
}

export default getters
